import React from 'react'

const Footer = () => {
  return (
    <>
        <footer className="w-full bg-blue-500 mt-auto py-4 px-4 border-t z-50">
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                    <div className="text-sm text-white">
                        © 2025 GrupoSumma. Todos los Derechos Revervados. 
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export default Footer
